module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--intersport-e8828591dccc77d8a4f77db5ed5c0e09.jpg";